import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { layout, token } from "@universityofmaryland/web-styles-library";
function createLayoutGridOffset({
  columns = 2,
  isLayoutReversed = false,
  stickyTopPosition = 0,
  stickyMinHeight = "560px",
  enableContainerQueries = false,
  alignItems = "start",
  overlayCardClass,
  overlayTextColor = token.color.white
} = {}) {
  let gridStyle = layout.grid.gap.two;
  if (columns === 3) gridStyle = layout.grid.gap.three;
  if (columns === 4) gridStyle = layout.grid.gap.four;
  const containerQueryStyles = enableContainerQueries ? {
    containerType: "inline-size"
  } : {};
  const alignmentMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch"
  };
  const stickyMediaQuery = {
    [`@media (${token.media.queries.large.min})`]: {
      position: "sticky",
      top: `${stickyTopPosition}px`,
      minHeight: stickyMinHeight
    }
  };
  const childStyles = isLayoutReversed ? {
    [`&.umd-layout-grid-offset > *:first-child`]: {
      order: 2
    },
    [`&.umd-layout-grid-offset > *:nth-child(2)`]: stickyMediaQuery
  } : {
    [`&.umd-layout-grid-offset > *:first-child`]: {
      order: -1,
      ...stickyMediaQuery
    }
  };
  const overlayCardStyles = overlayCardClass ? {
    [`& .${overlayCardClass}`]: {
      [`@media (${token.media.queries.large.min})`]: {
        height: "inherit"
      },
      [`*`]: {
        color: overlayTextColor
      },
      [`& > div`]: {
        [`@media (${token.media.queries.large.min})`]: {
          minHeight: `${stickyMinHeight} !important`
        }
      }
    }
  } : {};
  return new ElementBuilder().styled(gridStyle).withClassName("umd-layout-grid-offset").withStyles({
    element: {
      [` > *`]: {
        alignSelf: alignmentMap[alignItems],
        ...containerQueryStyles
      },
      ...childStyles,
      ...overlayCardStyles
    }
  }).build();
}
export {
  createLayoutGridOffset
};
//# sourceMappingURL=grid-offset.js.map
